/* eslint-disable no-lone-blocks */
import React, { Component } from 'react';
import { Select, Spin, Empty, DatePicker, InputNumber, Input, Modal, Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { excludesTableStore, excludesUpdateTableStore,optionsStore } from '../../../selectStore';
import postService from '../../../services/httpService';
import networkList from '../../../constants/networkList';
// import networkList from './../../constants/networkList';
import Select2 from '../../FormComponent/select2';
import InputNumberlayer from '../../FormComponent/InputNumberlayer';
import Datepicker from '../../FormComponent/Date';
import Checkboxlayer from '../../FormComponent/CheckboxLayer';
import {UPLOAD_URL} from '../../../constants/app-constants';

const { Option } = Select;
const {homepage} = networkList;
var url = window.location.href
var arr = url.split("/");
var hostname = arr[0] + "//" + arr[2]

class Tableantd extends Component {
    constructor(props) {
        super(props);
        this.state = {
            'table_head': [], 'table_body': [], 'add_more': false, 'add_more_title': null
        }

        excludesUpdateTableStore.subscribe(() => {
            this.updateTablebody();
        })
    }

    componentDidMount() {
        let { table_head, table_body, add_more, add_more_title } = this.props.table_data;
        this.setState({ 'table_head': table_head, 'table_body': table_body, 'add_more': add_more, 'add_more_title': add_more_title })
    }

    updateTablebody() {
        let { table_from } = this.props;
        if (table_from === 'excludes_schema') {
            console.clear();
            let table_data = excludesUpdateTableStore.getState();
            console.log(table_data);
            // let { table_body } = this.state;
            // excludesTableStore.dispatch({ type: 'options_data', 'data': table_body });
        }
    }

    handleChange(data) {
        let { name, id, value,selected_option,table } = data;
        let { slug } = this.props.match.params;
        const params = new URLSearchParams(this.props.location.search);
        const rid = params.get('rid');
        const cd = params.get('cd');

        this.setState({ error_message: '', error_view: false });
    if(table==='exlcudes' && table!==undefined  && table!==null && table!==undefined  ){
        if (rid != '' && rid !== undefined && rid !== null && !isNaN(rid) && slug === 'finanical-counselling') {
            slug = 'recounselling';
        }
        else if (slug === 'view-finanical-counselling') {
            slug = 'view-finanical-counselling';
        }
        else {
            slug = 'finanical-counselling';
        }

        switch (slug) {
            case 'view-finanical-counselling': {

                if (name === 'excludes_service_id') {
                    let { table_body } = this.state;
                    console.log(id, table_body)
                    table_body.map((body, key) => {
                        console.log(id, body['key'])
                        if (body['id'] == id && body['feilds']) {
                            body['feilds'].map((feild, feild_key) => {
                                let { price } = selected_option
                                if (feild.name === 'excludes_service_id') {
                                    table_body[key]['feilds'][feild_key]['selected_option'] = selected_option;
                                    table_body[key]['feilds'][feild_key]['text']=selected_option.service_name;
                                }
                                // if (feild.name === 'qty') {
                                //     table_body[key]['feilds'][feild_key]['value'] = 1
                                // }
                                // if (feild.name === 'rate') {
                                //     table_body[key]['feilds'][feild_key]['value'] = price
                                // }
                                // if (feild.name === 'amount') {
                                //     table_body[key]['feilds'][feild_key]['value'] = price;
                                // }
        
                            })
                        }
                    })
                   
                    this.setState({ 'table_body': table_body }, () => {
                        let { table_body } = this.state;
                        this.props.change(data);
                        excludesTableStore.dispatch({ type: 'options_data', 'data': table_body });
                    })
        
                }
               
                
                console.log('mani');
             

            }
            break;
            case 'finanical-counselling': {
                if (name === 'excludes_service_id') {
                    let { table_body } = this.state;
                    console.log(id, table_body)
                    table_body.map((body, key) => {
                        console.log(id, body['key'])
                        if (body['id'] == id && body['feilds']) {
                            body['feilds'].map((feild, feild_key) => {
                                let { price } = selected_option
                                if (feild.name === 'excludes_service_id') {
                                    table_body[key]['feilds'][feild_key]['selected_option'] = selected_option;
                                    table_body[key]['feilds'][feild_key]['text']=selected_option.service_name;
                                    table_body[key]['feilds'][feild_key]['package_id']=selected_option.package_id

                                }
                                if (feild.name === 'qty') {
                                    table_body[key]['feilds'][feild_key]['value'] = 1
                                }
                                if (feild.name === 'rate') {
                                    table_body[key]['feilds'][feild_key]['value'] = price
                                }
                                if (feild.name === 'amount') {
                                    table_body[key]['feilds'][feild_key]['value'] = price;
                                }
        
                            })
                        }
                    })
                   
                    this.setState({ 'table_body': table_body }, () => {
                        let { table_body } = this.state;
                        this.props.change(data);
                        excludesTableStore.dispatch({ type: 'options_data', 'data': table_body });
                    })
        
        
                }else if (name === "qty") {
                    let { table_body } = this.state;
                    console.log(id, table_body)
                    table_body.map((body, key) => {
                        console.log(id, body['key'])
                        if (body['id'] == id && body['feilds']) {
                            let quantity = 1;
                            let rate = 0
                            let excludes_service_id_=0
        
                            body['feilds'].map((feild, feild_key) => {
                                if (feild.name === 'excludes_service_id') {
                                    excludes_service_id_=feild.text;
                                }
                                if(excludes_service_id_!=null && excludes_service_id_!==''&& excludes_service_id_!==0){
                                    if (feild.name === 'qty') {
                                        table_body[key]['feilds'][feild_key]['value'] = value;
                                        quantity = value || 0
                                    }
                                    if (feild.name === 'rate') {
                                        rate = feild.value;
                                    }
                                    
                                    if (feild.name === 'amount') {
                                        table_body[key]['feilds'][feild_key]['value'] = parseFloat(quantity || 0) * parseFloat(rate);
                                    }
                                }
                                
                            })
                        }
                    })
                    this.props.change(data);
                    this.setState({ 'table_body': table_body }, () => {
                        let { table_body } = this.state;
                        excludesTableStore.dispatch({ type: 'options_data', 'data': table_body });
                    })
                }
                else if (name === "rate") {
                    let { table_body } = this.state;
                    
                    console.log(id, table_body)
                    table_body.map((body, key) => {
                        console.log(id, body['key'])
                        if (body['id'] == id && body['feilds']) {
                            let quantity = 1;
                            let rate = 0
                            body['feilds'].map((feild, feild_key) => {
                              
                                
                                if (feild.name === 'qty') {
                                    quantity = feild.value || 0 
                                }
        
                                if (feild.name === 'rate') {
                                    table_body[key]['feilds'][feild_key]['value'] = value;
                                    rate = value;
                                }
                                
                                if (feild.name === 'amount') {
                                    table_body[key]['feilds'][feild_key]['value'] = parseFloat(rate || 0) * parseFloat(quantity);
                                }
                            })
                        }
                    })
                    this.props.change(data);
                    this.setState({ 'table_body': table_body }, () => {
                        let { table_body } = this.state;
                        excludesTableStore.dispatch({ type: 'options_data', 'data': table_body });
                    })
                }

            }
            break;
            case 'recounselling': {
                if (name === 'excludes_service_id') {
                    let { table_body } = this.state;
                    console.log(id, table_body)
                    table_body.map((body, key) => {
                        console.log(id, body['key'])
                        if (body['id'] == id && body['feilds']) {
                            body['feilds'].map((feild, feild_key) => {
                                let { price } = selected_option
                                if (feild.name === 'excludes_service_id') {
                                    table_body[key]['feilds'][feild_key]['selected_option'] = selected_option;
                                    table_body[key]['feilds'][feild_key]['text']=selected_option.service_name;
                                    table_body[key]['feilds'][feild_key]['package_id']=selected_option.package_id
                                    table_body[key]['feilds'][feild_key]['disable']=true;
                                }
                                if (feild.name === 'qty' && feild.text===null && feild.value===null ) {
                                    table_body[key]['feilds'][feild_key]['value'] = 1
                                }
                                if (feild.name === 'rate' &&  feild.text===null && feild.value===null) {
                                    table_body[key]['feilds'][feild_key]['value'] = price
                                }
                                if (feild.name === 'amount' && feild.text===null && feild.value===null) {
                                    table_body[key]['feilds'][feild_key]['value'] = price;
                                }
        
                            })
                        }
                    })
                   
                    this.setState({ 'table_body': table_body }, () => {
                        let { table_body } = this.state;
                        this.props.change(data);
                        excludesTableStore.dispatch({ type: 'options_data', 'data': table_body });
                        console.log(table_body);
                    })
                  
        
        
                }else if (name === "qty") {
                    let { table_body } = this.state;
                    console.log(id, table_body)
                    table_body.map((body, key) => {
                        console.log(id, body['key'])
                        if (body['id'] == id && body['feilds']) {
                            let quantity = 1;
                            let rate = 0;
                            let excludes_service_id_=0;
        
                            body['feilds'].map((feild, feild_key) => {
                                
                                if (feild.name === 'excludes_service_id') {
                                    excludes_service_id_=feild.text;
                                }
                                if(excludes_service_id_!=null && excludes_service_id_!==''&& excludes_service_id_!==0){
                                    if (feild.name === 'qty') {
                                        table_body[key]['feilds'][feild_key]['value'] = value;
                                        quantity = value || 0
                                    }
                                    if (feild.name === 'rate') {
                                        rate = feild.value;
                                    }
                                    
                                    if (feild.name === 'amount') {
                                        table_body[key]['feilds'][feild_key]['value'] = parseFloat(quantity || 0) * parseFloat(rate);
                                    }
                                }
                               
                            })
                        }
                    })
                    this.props.change(data);
                    this.setState({ 'table_body': table_body }, () => {
                        let { table_body } = this.state;
                        excludesTableStore.dispatch({ type: 'options_data', 'data': table_body });
                    })
                }
                else if (name === "rate") {
                    let { table_body } = this.state;
                    
                    console.log(id, table_body)
                    table_body.map((body, key) => {
                        console.log(id, body['key'])
                        if (body['id'] == id && body['feilds']) {
                            let quantity = 1;
                            let rate = 0
                            body['feilds'].map((feild, feild_key) => {
                              
                                
                                if (feild.name === 'qty') {
                                    quantity = feild.value || 0
                                }
        
                                if (feild.name === 'rate') {
                                    table_body[key]['feilds'][feild_key]['value'] = value;
                                    rate = value;
                                }
                                
                                if (feild.name === 'amount') {
                                    table_body[key]['feilds'][feild_key]['value'] = parseFloat(rate || 0) * parseFloat(quantity);
                                }
                            })
                        }
                    })
                    this.props.change(data);
                    this.setState({ 'table_body': table_body }, () => {
                        let { table_body } = this.state;
                        excludesTableStore.dispatch({ type: 'options_data', 'data': table_body });
                    })
                }
            }
            break;
            default:
            break;    
        }
    }else{
        this.props.change(data);  
    }
       
    }

    addButton() {
        let { table_from } = this.props;
        try {
            let add_more_feilds = this.props.table_data.add_more_feilds;
            let { table_body } = this.state;

            let last_element = table_body[table_body.length - 1];
            let last_id = (last_element && last_element['id']) ? last_element['id'] : 0;
            let add_more = JSON.parse(JSON.stringify(add_more_feilds));

            add_more.map((feild, key) => {
                add_more[key]['id'] = last_id + 1;
                add_more[key]['value'] = null;
                add_more[key]['text'] = null;
            })

            let obj = [{
                'id': last_id + 1,
                'key_word': 'add_more',
                text: "Highend", type: "text", input_feild: [],
                'feilds': add_more
            }]
            if (table_from !== 'excludes_schema') {
                this.props.change(obj);
                this.setState((state) => ({ 'table_body': state.table_body.concat(obj) }), () => {
                    let { table_body } = this.state;
                    console.log(table_body)
                })
            }
            // this.props.change(obj);
            if (table_from === 'excludes_schema') {
                this.setState((state) => ({ 'table_body': state.table_body.concat(obj) }), () => {
                    let { table_body } = this.state;
                    console.log(table_body)
                })
            }
        } catch (error) {
            console.log(error);
        }
    }

    deleteRow(row_id) {
        let table_body = this.state.table_body;
        let { table_from, form_table } = this.props;

        // if (row_id) {
        try {
            if (table_body.length > 1) {
                let removed_obj = table_body.splice(row_id, 1);
                if (table_from !== 'excludes_schema') {
                    this.props.deleteLineItem(removed_obj);
                }
            } else {
                if (row_id === 0 && form_table !== 'additional_packages' && form_table !== 'additional_procedures' ) {
                    table_body.map((body, key) => {

                        if (key === row_id && body['feilds']) {
                            body['feilds'].map((feild, feild_key) => {
                                if (feild.name === 'excludes_service_id') {
                                    table_body[key]['feilds'][feild_key]['selected_option'] = null;
                                    table_body[key]['feilds'][feild_key]['value'] = null;
                                    table_body[key]['feilds'][feild_key]['text'] = null;
                                }
                                if (feild.name === 'additional_surgery_procedure_name') {
                                    table_body[key]['feilds'][feild_key]['selected_option'] = null;
                                    table_body[key]['feilds'][feild_key]['value'] = null;
                                    table_body[key]['feilds'][feild_key]['text'] = null;
                                }
                                if (feild.name === 'additional_package_name') {
                                    table_body[key]['feilds'][feild_key]['selected_option'] = null;
                                    table_body[key]['feilds'][feild_key]['value'] = null;
                                    table_body[key]['feilds'][feild_key]['text'] = null;
                                }
                                if (feild.name === 'qty') {
                                    table_body[key]['feilds'][feild_key]['value'] = null
                                }
                                if (feild.name === 'rate') {
                                    table_body[key]['feilds'][feild_key]['value'] = null
                                }
                                if (feild.name === 'amount') {
                                    table_body[key]['feilds'][feild_key]['value'] = null;
                                }

                            })
                        }
                    })
                }
                if (row_id === 0 && (form_table === 'additional_packages' || form_table === 'additional_procedures' || form_table === 'ailment_capping' || form_table ==='interim' || form_table ==='previlage' || form_table==='nme')) {
                    let removed_obj = table_body.splice(row_id, 1);
                    this.props.deleteLineItem(removed_obj);
                }
            }

            this.setState({ 'table_body': table_body }, () => {
                if (table_from === 'excludes_schema') {
                    let { table_body } = this.state;
                    excludesTableStore.dispatch({ type: 'options_data', 'data': table_body });
                }
            })


        } catch (error) {
            console.log(error);
        }
        // }
    }
    render() {
        let { table_head, table_body, add_more, add_more_title } = this.state;
        let { slug } = this.props.match.params;
        if (slug === 'view-finanical-counselling') {
            add_more = false;
        }
        else if (slug === 'finanical-counselling') {
            if (add_more_title === 'Add Additional package') {
                add_more = true;
            }
            else if (add_more_title === 'Add Additional Procedure') {
                add_more = true;
            }
            else if (add_more_title === 'Add Highend Room Investigation') {
                add_more = true;
            }
            else if (add_more_title === 'Add Highend ICU Investigation') {
                add_more = true;
            }
            else if (add_more_title === 'Add Highend Drugs') {
                add_more = true;
            }
            else if (add_more_title === 'Add Highend Drugs') {
                add_more = true;
            }
            else if (add_more_title === 'Add Highend Drugs') {
                add_more = true;
            }
            else if (add_more_title === 'Add OT Equipment') {
                add_more = true;
            }
            else if (add_more_title === 'Add Procedure') {
                add_more = true;
            }
            else if (add_more_title === 'Add Blood Bank Component') {
                add_more = true;
            }
            else if (add_more_title === 'Add Cross Consultation') {
                add_more = true;
            }
            else if (add_more_title === 'Add Interim') {
                add_more = true;
            }
            else if (add_more_title === 'Add Pre-Existing Condition') {
                add_more = true;
            }
            else if (add_more_title === 'Add Ailment Capping') {
                add_more = true;
            } else if (add_more_title === 'Add Excludes') {
                add_more = true;
            }
            // else if (add_more_title === 'Add NME') {
            //     add_more = true;
            // }
            else if (add_more_title === 'Add General Equipment Charges') {
                add_more = true;
            }
            else if (add_more_title === 'Add Physiotherapy') {
                add_more = true;
            }
            else if (add_more_title === 'Add Seropsitive') {
                add_more = true;
            }
            else if (add_more_title === 'Add OT Charges') {
                add_more = true;
            }
            else if (add_more_title === 'Add Highend Drugs & Implants') {
                add_more = true;
            }
            else {
                add_more = false;
            }
        }

        const {
            getOtHours,
            getRoomIsolationCharges,
            getIcuIsolationCharges
        } = networkList;
        return (<table className="table table-hover table-bordered">
            <thead>
                <tr>
                    {table_head.map((head, hKey) => {
                        return (<td style={{ width: head.width, position: 'sticky', top: 0, backgroundColor: '#87979f', zIndex: 10 }} key={hKey}>{head.text}</td>)
                    })}

                </tr>
            </thead>

            <tbody>

                {table_body.length > 0 && table_body.map((feild, index) => {
                    return (
                        <tr key={index}>
                            {(slug === 'view-finanical-counselling'&&feild.key_word==='in_asst_physician_fees')?<td>{index + 1}</td>:feild.key_word!=='in_asst_physician_fees'&&<td>{index + 1}</td>}

                            {feild.feilds.map((input, inkey) => {
                                if (input.visible && input.element === 'input') {
                                    return (
                                        <td key={inkey}>
                                            {/* <div className=""> */}
                                            {/* <div className={`${input.className ? input.className : 'col'} my-2 ${input.name}`} key={key}>
                                                <div className="clearfix">
                                            </div> */}
                                            <InputNumberlayer {...this.props} {...this.state} selectdata={input} onInputChanges={this.handleChange.bind(this)} />
                                            {/* <div className="form-group mb-0">
                                                    {input.disable && input.type !== 'number' && <Input className="mb-0 disable ant-input ant-input-disabled" disabled placeholder={input.placeholder} defaultValue={input.value}/>}
                                                    {input.disable  && <React.Fragment> {input.type === 'number' && <InputNumber  className="mb-0 disable ant-input ant-input-disabled" disabled formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')} value={input.value} parser={value => value.replace(/\$\s?|(,*)/g, '')} min={0} placeholder={input.placeholder} />
                                                    } </React.Fragment>}
                                                    {input.disable === false && <React.Fragment>
                                                    {input.type === 'number' && 
                                                    <InputNumber formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')} value={input.value} parser={value => value.replace(/\$\s?|(,*)/g, '')} min={0} placeholder={input.placeholder} onChange={this.handleChange.bind(this)}/>
                                                    }
                                                     {input.type === 'text' && 
                                                     <input className={`${input.disable ? 'mb-0 disable ant-input ant-input-disabled' : "ant-input"}`} placeholder={input.placeholder} type={input.type} name={input.name} disabled={input.disable} defaultValue={input.value} autocomplete="off" />
                                                     }   
                                                     </React.Fragment>}
                                                    </div> */}
                                            {/* </div> */}
                                            {/* </div> */}
                                        </td>
                                    )
                                }
                                if (input.visible && input.element === 'select') {
                                    return (
                                        <React.Fragment key={index}>
                                            <td key={inkey}>
                                                <div className="row mx-0">
                                                    <div className="col px-0">
                                                        <Select2
                                                            selectdata={input}
                                                            changedObj={this.state.changedObj}
                                                            {...this.props}
                                                            {...this.state}
                                                            Queuedata={this.state.formData}
                                                            onselectChanges={this.handleChange.bind(this)} />
                                                        {input.errors.map((error, eKey) => {
                                                        return (
                                                                <small key={eKey} className="form-text text-danger" id={'errormalment'+input.id}>{error.message}</small>
                                                            );
                                                        })}
                                                    </div>
                                                </div>
                                            </td>
                                        </React.Fragment>
                                    )
                                    // }
                                    //     else{
                                    //     return (
                                    //         <td key={inkey}>
                                    //             <div className="row mx-0">
                                    //                 <div className="col px-0">
                                    //                     {/* <div className="form-group mb-0"> */}
                                    //                     <Select
                                    //                         showSearch
                                    //                         allowClear={true}
                                    //                         placeholder={input.placeholder}
                                    //                         style={{ width: '100%', height: '30px' }} >

                                    //                         <Option value="jack">1</Option>
                                    //                         <Option value="lucy">2</Option>
                                    //                         <Option value="Yiminghe">3</Option>
                                    //                     </Select>
                                    //                     {/* </div> */}
                                    //                 </div>
                                    //             </div>
                                    //         </td>
                                    //     )
                                    // }
                                }
                                if (input.visible && input.element === 'datepicker') {
                                    return (
                                        <td key={inkey}>
                                            {/* <div className="row mx-2">
                                                <div className="col">
                                                    <div className="form-group mb-0"> */}
                                            <Datepicker selectdata={input}
                                                changedObj={this.state.changedObj}
                                                {...this.props}
                                                {...this.state}
                                                Queuedata={this.state.formData}
                                                onselectChanges={this.handleChange.bind(this)} />
                                            {/* <DatePicker
                                                        disabled={input.disable ? input.disable : false}
                                                        mode={input.type}
                                                        style={{ width: '100%' }}
                                                        placeholder={input.placeholder}>
                                                        </DatePicker>    */}
                                            {/* </div>
                                                </div>
                                            </div> */}
                                        </td>
                                    )
                                }
                                if (input.visible && input.element === 'checkbox') {
                                    return (
                                        <td key={inkey}>
                                            {/* <div className="row mx-2">
                                                <div className="col">
                                                    <div className="form-group mb-0">
                                                        <label>
                                                        <input
                                                        type="checkbox"
                                                        name={input.name}
                                                        disabled={input.disable ? input.disable : false} />
                                                        <span></span>
                                                        </label>                                                      
                                                    </div>
                                                </div>
                                            </div> */}
                                            <Checkboxlayer selectdata={input}
                                                changedObj={this.state.changedObj}
                                                {...this.props}
                                                {...this.state}
                                                Queuedata={this.state.formData}
                                                onselectChanges={this.handleChange.bind(this)} />
                                        </td>
                                    )
                                }
                                if (input.visible && input.element === 'action') {
                                    return (
                                        <td key={inkey}>
                                            <Tooltip placement="top" title='Remove'>
                                                <img src="/assets/images/icons/delete.png" alt="Remove" className="mr-2" onClick={this.deleteRow.bind(this, index)} />
                                            </Tooltip>
                                        </td>
                                    )
                                }
                                if (input.visible && input.element === 'text') {
                                    return (
                                        <td key={inkey} colSpan={input.colSpan}>
                                            {input.tooltip ? <Tooltip   placement="topRight" color={'red'} title={input.tooltip}>{input.title}
                                                <InfoCircleOutlined style={{ "font-size": "16px", "margin-left": "20px" }} />
                                            </Tooltip> :input.text? input.text:input.title}
                                        </td>
                                    )
                                }
                                if(input.visible && input.element==='a'){
                                    let href = `${hostname}/counselling/view-document?uid=${input.umr_no}&ip=${input.ip_no}&name=${input.patient_name}&file=${input['text'] && input['text'].replaceAll("&", "_ampersand_")}`;
                                
                                if (slug === 'pre-auth-worklist' || slug === 'post-auth-worklist' || slug === 'query-worklist' || slug === 'gre-worklist' || slug === 'dmo-worklist') {
                                    href = `${UPLOAD_URL}${input.umr_no}/${input['text']}`;
                                }
                                    return (
                                        <td key={inkey}>
                                            <Tooltip title="Click to View"><a href={href} target="_blank" className="pr-2">{input['text']}</a></Tooltip>
                                            {/* <Tooltip title="Click to View"><a  className="pr-2">{input['text']}</a></Tooltip> */}

                                            {/* /{(body[head['key']] !== null) ? body[head['key']] : '--'} */}
                                        </td>
                                    )
                                }
                            })}

                        </tr>)


                })}

                {(add_more) && <tr>
                    <td colSpan={table_head.length} className="text-right">
                        <button className="btn btn-success" onClick={() => this.addButton(this)}>{add_more_title}</button>
                    </td>
                </tr>
                }
            </tbody>
        </table>)
    }
}

export default Tableantd;
